export default "__VITE_ASSET__WwFuS8FI__"